'use client';

import Link from 'next/link';
import { Anchor, Container, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { getCarComparisonLinkProps } from '../../../lib/content/comparisonLinks';
import type { PageWidgetItem } from '../../../types/content';
import {
  getWidgetCardStyle,
  widgetSectionPadding,
  widgetSubtitleStyle,
  widgetTitleStyle,
} from './widgetStyles';

export function ResourceListWidget({
  title,
  subtitle,
  items,
  mapHref,
}: {
  title?: string;
  subtitle?: string;
  items: PageWidgetItem[];
  mapHref: (href?: string) => string | undefined;
}) {
  if (!items.length) return null;

  return (
    <Container size="xl" py={widgetSectionPadding}>
      <Stack gap={12}>
        {title ? <Title order={2} style={widgetTitleStyle}>{title}</Title> : null}
        {subtitle ? <Text style={widgetSubtitleStyle}>{subtitle}</Text> : null}

        <Stack gap={12}>
          {items.map((item, index) => {
            const href = mapHref(item.href);
            return (
              <Paper
                key={`${item.title || 'resource'}-${index}`}
                p={20}
                radius={28}
                withBorder
                style={getWidgetCardStyle(index)}
              >
                <Group justify="space-between" align="center" wrap="nowrap">
                  <Stack gap={4} style={{ flex: 1 }}>
                    <Text fw={600} style={{ color: 'var(--text-primary)' }}>{item.title || item.label || `Resource ${index + 1}`}</Text>
                    {item.body ? <Text size="sm" style={{ ...widgetSubtitleStyle, maxWidth: 'unset' }}>{item.body}</Text> : null}
                  </Stack>

                  {href ? (
                    <Anchor
                      component={Link}
                      href={href}
                      {...getCarComparisonLinkProps(href)}
                      style={{ color: 'var(--text-primary)', display: 'inline-flex', alignItems: 'center', gap: 6 }}
                      underline="never"
                    >
                      <IconArrowRight size={16} />
                    </Anchor>
                  ) : null}
                </Group>
              </Paper>
            );
          })}
        </Stack>
      </Stack>
    </Container>
  );
}
